import {Company} from "../../../../models/Company";
import React from "react";
import CompanyNotesTable from "../CompanyNotesTable";

export default function NotesTab(props: { company: Company }) {

    const { company } = props;

    return (
        <>
            <CompanyNotesTable company={company} />
        </>
    )
}
